package ru.arty_bikini.crm_frontend.util

object Debug {
    const val debugEnabled: Boolean = false
}
